import { mapState } from 'vuex';
import FieldValidator from '@/views/calculators/services/fieldValidatorService';
import { AccidentChildrenSettings } from '../AccidentChildrenSettings';
import ExistingAbProductsComponent from '../../components/ExistingABProductsComponent.vue';
import { Options, Vue } from 'vue-class-component';
import { PropType } from 'vue';
import { CardBlock } from '@/cms/definitions/content-types';
import { Validator } from '../../services/ValidationService';
import { handleZipCodePrefill } from '../../services/UiStepService';

@Options({
	name: 'PersonInfoStepComponent',
	props: {
		card: Object as PropType<CardBlock>,
		isValid: Boolean,
	},
	components: {
		ExistingAbProductsComponent,
	},
	computed: mapState<any>({
		model: (state) => state.calculatorContext[state.calculatorContext.active].model,
		cms: (state) => state.calculatorContext[state.calculatorContext.active].cms,
	}),
})
export default class PersonInfoStepComponent extends Vue {
	card: CardBlock; // Card from cms
	isValid: boolean; // whether card is complete

	public model!: any; // data structure for user input (store)
	public cms!: AccidentChildrenSettings; // settings from CMS (store)

	public fieldValidator: FieldValidator = Validator;
	public defaultZip: string = null;

	public created() {
		const zipParam = (this.$route.query.zipCode as string) || (this.$route.query.zipcode as string);
		if (zipParam) {
			this.defaultZip = zipParam;
		}
	}

	public mounted() {
		handleZipCodePrefill(this.model.personInfo, this.cms);
		addEventListener('keyup', this.moveOn);
	}

	public beforeUnmount() {
		removeEventListener('keyup', this.moveOn);
	}

	public moveOn(evt) {
		if (evt.keyCode === 13 && this.isValid) {
			this.nextStep();
		}
	}

	public zipSearch(data) {
		if (data.matchText) {
			this.model.personInfo.zipCode = data.zipCode;
			this.model.personInfo.zipName = data.zipName;
			this.model.pristineStep.set(this.card.name, true);
			return;
		}
		this.model.personInfo.zipCode = undefined;
		this.model.personInfo.zipName = undefined;
	}

	public nextStep() {
		this.$emit('nextStep', this.card.routePath);
	}
}
